import { ProjectReviewEntity } from '../types';
import { ChangeTypeDisplay, ENTITY_BADGE_DISPLAY } from './model';

export const formatEnumLabel = (value: string): string =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .toLowerCase()
    .split('_')
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getEntityCounts = (entities: ProjectReviewEntity[]) =>
  entities.reduce(
    (counts, entity) => ({
      changesCount: counts.changesCount + entity.changes.filter(change => change.property !== null).length,
      staleItemsCount: counts.staleItemsCount + entity.violations.length,
    }),
    { changesCount: 0, staleItemsCount: 0 },
  );

export const getEntityBadge = (entity: ProjectReviewEntity): ChangeTypeDisplay | null => {
  if (entity.changes.some(change => change.changeType === 'DELETED')) return ENTITY_BADGE_DISPLAY.DELETED ?? null;
  if (entity.changes.some(change => change.changeType === 'CREATED')) return ENTITY_BADGE_DISPLAY.CREATED ?? null;
  if (entity.changes.length) return ENTITY_BADGE_DISPLAY.UPDATED ?? null;

  return null;
};

export const getOwnerDisplayName = (owner: string, employeeName: any) => {
  if (employeeName?.nameEn) {
    const { firstName, lastName } = employeeName.nameEn;
    const displayName = `${firstName || ''} ${lastName || ''}`.trim();

    if (displayName) return displayName;
  }

  return employeeName?.name || employeeName?.fullName || owner;
};
